// @tenorlab/nuxt-dashboard-pro
// file: app/config/config-files-map.ts
// file: src/config/config-files-map.ts

// import a reference to our Config interface:
import type { IConfig } from './models/Config.interface'

// individual environments configs:
import configDev from './config-files/dev.json'
import configProduction from './config-files/production.json'

// example with javascript Map()
export const configFilesMap: Map<string, IConfig> = new Map<string, IConfig>([
  ['dev', <any>configDev],
  ['production', <any>configProduction],
])
